import React, { Component } from "react";
import { connect } from "react-redux";
import Topbar from './components/Topbar';
import Sidebar from "./components/Sidebar";
import Loading from '../../admin/components/Loading';
import { MDBDataTable } from "mdbreact";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const mySwal = withReactContent(Swal);

class UserPerformance extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggled: false,
            data: null,
            loading: false,
            startDate: "",
            endDate: "",
            operatorId: ""
        };
    }

    componentDidMount() {
        if (!this.props.distributor) {
            return this.props.history.push('/distributor');
        }
    };

    handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

    handleChange = e => this.setState({
        ...this.state,
        [e.target.id]: e.target.value
    });

    handleDate = dates => {
        const [start, end] = dates;
        this.setState({
            ...this.state,
            startDate: start,
            endDate: end
        });
    };

    handleFilter = e => {
        const { operatorId, startDate, endDate } = this.state;
        let operatorIds = [];
        for (let i = 0; i < this.props.distributor.admin.length; i++) {
            operatorIds.push(this.props.distributor.admin[i].operatorId);
        }
        let sendThis = {
            operatorIds
        };

        if (operatorId) {
            sendThis.operatorId = operatorId;
        }
        if (startDate && endDate) {
            sendThis.startDate = new Date(startDate);
            sendThis.endDate = new Date(endDate).setHours(23, 59, 59, 999);
        }
        this.setState({
            ...this.state,
            loading: true
        });
        axios
            .post("/api/distributor/report/user", sendThis)
            .then(res => {
                this.setState({
                    ...this.state,
                    loading: false,
                    data: res.data.data
                });
            })
            .catch(err => {
                this.setState({
                    ...this.state,
                    loading: false
                });
                mySwal.fire("Error", err.response.data.error, "error");
            });
    };

    handleReset = e => {
        this.setState({
            ...this.state,
            outletId: "",
            startDate: "",
            endDate: "",
            operatorId: "",
            data: null
        });
    };

    render() {
        let data = {
            columns: [
                {
                    label: "Name",
                    field: "userName",
                    sort: "asc"
                },
                {
                    label: "Number",
                    field: "number",
                    sort: "asc"
                },
                {
                    label: "Join Date",
                    field: "joinedDate",
                    sort: "asc"
                },
                {
                    label: "Total Stamps",
                    field: "totalStamps",
                    sort: "asc"
                },
                {
                    label: "Total Spent (RM)",
                    field: "totalSpent",
                    sort: "asc"
                },
                {
                    label: "e-Token Spent",
                    field: "tokenSpent",
                    sort: "asc"
                },
                {
                    label: "Last Transaction Date",
                    field: "lastTransaction",
                    sort: "asc"
                },
                {
                    label: "Voucher Collected",
                    field: "voucherAcquired",
                    sort: "asc"
                },
                {
                    label: "Voucher Spent",
                    field: "voucherUsed",
                    sort: "asc"
                },
                {
                    label: "Washer Used",
                    field: "washerUsed",
                    sort: "asc"
                },
                {
                    label: "Dryer Used",
                    field: "dryerUsed",
                    sort: "asc"
                }
            ],
            rows: this.state.data ?? []
        };

        return (
            <div className="admin-page-container">
                <Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />
                <div className="admin-page">
                    <Topbar handleToggle={this.handleToggle} />
                    <div className="admin-content">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">User Performance</h5>
                            </div>

                            <div className="card-body">
                                <div className="mb-5">
                                    <h6>Filter</h6>
                                    <div>
                                        <label htmlFor="outletId">Select Operator: </label>
                                        <select id="operatorId" name="operatorId" className="browser-default form-select" value={this.state.operatorId} onChange={this.handleChange}>
                                            <option disabled value="">Select Operator</option>
                                            {
                                                this.props.distributor.admin.map(admin => <option key={admin.operatorId} value={admin.operatorId}>{admin.username}</option>)
                                            }
                                        </select>
                                    </div>

                                    <div>
                                        <label htmlFor="date">Select Date: </label>
                                        <DatePicker value={`${this.state.startDate ? new Date(this.state.startDate).toLocaleDateString() : ""} - ${this.state.endDate ? new Date(this.state.endDate).toLocaleDateString() : ""}`} onChange={this.handleDate} startDate={this.state.startDate} endDate={this.state.endDate} selectsRange shouldCloseOnSelect={false} />
                                    </div>

                                    <div className="d-flex">
                                        <button onClick={this.handleFilter} className="btn btn-primary btn-inline form-control me-3">
                                            Filter
                                        </button>
                                        <button onClick={this.handleReset} className="btn btn-secondary btn-inline form-control ms-3">
                                            Reset
                                        </button>
                                    </div>
                                </div>
                                <div className="text-center mt-5">{this.state.loading ? <Loading /> : <MDBDataTable data={data} noBottomColumns striped hover responsive bordered />}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        distributor: state.distributor.distributor
    };
};

export default connect(mapStateToProps, null)(UserPerformance);
